<template>
  <div>
    <div
      class="modal fade"
      id="addAttachment"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="addAttachmentLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">أضافة ملف</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="this.clearData()"></button>
          </div>
          <div class="modal-body">
            <form id="addFile" @submit.prevent="addNewFile($event)">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="lessonFileName">اسم الملف</label>
                    <input type="text" class="form-control" id="lessonFileName" placeholder="اسم الملف" v-model="file_data.title" required />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group files">
                    <label for="lessonFile">أضف الملف</label>
                    <!-- Custom Input File -->
                    <div class="dragDrop small" @dragover="onDropOver($event)" @dragleave="onDropLeave($event)">
                      <div v-if="this.file == null" class="dragDrop__input">
                        <div class="dragDrop__input__icon">
                          <i class="fa fa-upload icon" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div v-else class="dragDrop__file">
                        <div class="dragDrop__file__icon">
                          <i class="fa fa-file icon" aria-hidden="true"></i>
                        </div>
                        <div class="dragDrop__file__text">
                          <span>{{ this.file.name }}</span>
                        </div>
                      </div>
                      <input
                        type="file"
                        id="chooseFiles"
                        placeholder="أضف الملف"
                        required
                        @change="onFileSelect($event)"
                        accept="application/pdf"
                        autocomplete="off"
                      />
                    </div>
                    <!-- Custom Input File -->
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="fileImage">صورة الملف (اختيارى)</label>
                    <UploadImages
                      class="form-control mt-2"
                      @changed="handlefileImages"
                      id="questionImage"
                      :max="1"
                      maxError="يمكنك رفع صورة واحدة لكل سوال"
                      fileError="لا يمكن رفع ملفات غير الصور"
                    />
                  </div>
                </div>

                <div class="col-12">
                  <div class="buttons__container text-start">
                    <button type="submit" class="btn add w-100">إضافة</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  // Swal
  import Swal from 'sweetalert2';
  // Firebase Upload Component
  import FirebaseUploadingFileVue from '@/components/FirebaseUploadingFile.vue';
  // Toast to Show Message
  import { useToast, TYPE } from 'vue-toastification';
  const toast = useToast();
  // Upload Image Drag and Drop
  import UploadImages from 'vue-upload-drop-images';
  export default {
    name: 'UploadAttachments',
    components: { UploadImages },
    data() {
      return {
        file_data: {},
        file: null,
      };
    },
    methods: {
      ...mapActions('ViewVideoModule', ['addAttachment']),
      clearData() {
        this.file = null;
        this.file_image = null;
        let clearButton = document.querySelector('.clearButton');
        clearButton.click();
        document.getElementById('chooseFiles').value = '';
        document.getElementsByClassName('dragDrop')[0].classList.remove('drop_zone');
      },
      async addNewFile(event) {
        let closeButton = event.target.parentNode.parentNode.firstChild.querySelector('button');

        let fileExtension = this.file.name.split('.').pop();

        if (fileExtension == 'pdf') {
          this.file_data.file_type = 2;
          this.UpdateType = 'application/pdf';
        } else {
          this.file_data.file_type = 1;
          this.UpdateType = 'image/jpeg';
        }

        if (this.file !== null) {
          const content = {
            // Your component or JSX template
            component: FirebaseUploadingFileVue,
            // Props are just regular props, but these won't be reactive
            props: {
              title: 'يتم رفع الملف الان',
              file: this.file,
              collection: 'Files',
              // pdf: this.file,
              contentType: this.UpdateType,
              onFinished: (url) => {
                this.file_data.url = url ?? '';
                toast.dismiss(toastId);
                if (this.file_image) {
                  const content = {
                    component: FirebaseUploadingFileVue,
                    props: {
                      title: 'يتم رفع صورة الملف الان',
                      file: this.file_image,
                      collection: 'Files',
                      onFinished: (url) => {
                        this.file_data.image_url = url ?? '';
                        toast.dismiss(toastId);
                        this.addAttachment({ file: this.file_data, video_id: this.$route.params.video_id });
                        closeButton.click();
                        this.file_data = {
                          type: 1,
                          url: '',
                          title: '',
                          size: '', // file size
                          file_type: '', // 1 => image -- // 2 => pdf
                          file_id: '', // file name
                          created_date: new Date().toISOString(), // Timestamp
                        };
                        this.clearAndShowSuccess('تم إضافة الملف بنجاح');
                      },
                    },
                  };
                  const toastId = toast(content, {
                    icon: false,
                    hideProgressBar: true,
                    closeButton: false,
                    type: TYPE.INFO,
                    timeout: false,
                    toastClassName: 'my-custom-toast-class',
                  });
                } else {
                  this.addAttachment({ file: this.file_data, video_id: this.$route.params.video_id });
                  closeButton.click();
                  this.file_data = {
                    type: 1,
                    url: '',
                    title: '',
                    size: '', // file size
                    file_type: '', // 1 => image -- // 2 => pdf
                    file_id: '', // file name
                    created_date: new Date().toISOString(), // Timestamp
                  };
                  this.clearAndShowSuccess('تم إضافة الملف بنجاح');
                }
              },
            },
          };

          const toastId = toast(content, {
            icon: false,
            hideProgressBar: true,
            closeButton: false,
            type: TYPE.INFO,
            timeout: false,
            toastClassName: 'my-custom-toast-class',
          });
          closeButton.click();
        }
      },
      onDropOver($event) {
        let el = $event.currentTarget;
        el.classList.add('drop_zone');
      },
      // Drop Leave Elemet area
      onDropLeave($event) {
        let el = $event.currentTarget;
        el.classList.remove('drop_zone');
      },
      handlefileImages(files) {
        this.file_image = files[0];
      },
      clearAndShowSuccess(message) {
        this.seccussAdd(message);
        this.clearData();
      },
      seccussAdd(message) {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: 'success',
          title: message,
        });
      },
      // When Select File
      onFileSelect(e) {
        let file = e.target.files[0] || e.dataTransfer;
        this.file = file;
        this.file_data.file_id = file.name;
        this.file_data.size = file.size;

        //  Change file_type Number to Know File Type
        if (file.type.includes('image')) {
          this.file_data.file_type = 1;
        } else if (file.type.includes('pdf')) {
          this.file_data.file_type = 2;
        }
        //  Change Type Number to Know File Type
        if (file.type.includes('image') || file.type.includes('pdf')) {
          this.file_data.type = 1;
          if (file.type.includes('image')) {
            this.file_data.file_type = 1;
          } else if (file.type.includes('pdf')) {
            this.file_data.file_type = 2;
          }
        } else if (file.type.includes('video')) {
          this.file_data.type = 2;
        }
      },
    },
  };
</script>
